'use strict';

angular.module('mean.projects').factory('optionPlanService', ['$filter', '$q', 'taskService', 'toaster', 'aceUtils', 'optionService', 'taskTotalsService',
    function($filter, $q, taskService, toaster, aceUtils, optionService, taskTotalsService) {

        //matrix_values is ($scope.matrix_values)
        //trade is ($scope.user.trade[0])
        var buildPlan = function(plan, item, matrix_values, trade) {
            var inlist = $filter('filter')(matrix_values, {
                'number': item.number}, true);

            if(inlist.length === 0) {
                matrix_values.push({
                    number: item.number,
                    name: item.name,
                    description: item.description,
                    plans: []
                });

                matrix_values[matrix_values.length-1].plans.push({
                    plan: plan,
                    option: 0,
                    original: 0,
                    value: 0
                });

            } else if(inlist.length === 1) {
                var has_plan = $filter('filter')(inlist[0].plans, {
                    'plan': plan }, true);

                if(has_plan.length === 0) {
                    inlist[0].plans.push({
                        plan: plan,
                        option: 0,
                        original: 0,
                        value: 0
                    });
                }
            }
        };

        //matrix_values is ($scope.matrix_values)
        //bid_list is ($scope.bid_list)
        //options is ($scope.my_options.options)
        var planTotal = function(plan, item, matrix_values, bid_list, options) {
            var value = item.plans.indexOf(plan) !== -1;
            
            var inlist = $filter('filter')(matrix_values, {
                'number': item.number}, true);
            var has_plan = $filter('filter')(inlist[0].plans, {
                'plan': plan }, true);
     
            if(value && (has_plan.length === 1)) {
                var totals = {
                    option: 0,
                    original: 0
                }

                var bid_task = $filter('filter')(bid_list, { 
                    'plan': plan }, true);

                _.each(bid_task, function(bid) {
                    var option = $filter('filter')(options, {
                        'number': item.number }, true);

                    if(bid.revision === option[0].bid_revision) {
                        var revision = 1;

                        if(option[0].revisions && option[0].revisions.length > 0)
                            revision = option[0].revisions[option[0].revisions.length-1].number;

                        if(option.length === 1) {
                            _.each(option[0].subtasks, function(sub) {
                                if(bid.task === sub.task && 
                                    sub.plan === plan && sub.revision === revision) {

                                    totals.option += 
                                        sub.is_overridden?sub.overridden_total:sub.total;

                                    if(sub.bid_subtask)
                                        totals.original += 
                                            (bid.subtasks[sub.subtask_array_id]) ? 
                                                bid.subtasks[sub.subtask_array_id].total : 0;
                                }
                            });
                        }
                    }
                });

                has_plan[0].original = totals.original;
                has_plan[0].option = totals.option;
                has_plan[0].value = has_plan[0].option - has_plan[0].original;
            } else {
                has_plan[0].value = 'X';
            }

            return has_plan;
        };

        //matrix_values is ($scope.matrix_values)
        //bid_list is ($scope.bid_list)
        //options is ($scope.my_options.options)
        var planOptionRevisionTotal = function(
            plan, item, matrix_values, bid_list, options, option_revision) {
            var value = item.plans.indexOf(plan) !== -1;
            
            var inlist = $filter('filter')(matrix_values, {
                'number': item.number}, true);
            var has_plan = $filter('filter')(inlist[0].plans, {
                'plan': plan }, true);
     
            if(value && (has_plan.length === 1)) {
                //this is added because if not here, the option edit view
                //does not allow the user to edit an option total.
                if(has_plan[0].currentValueEditing) return null;

                var totals = {
                    option: 0,
                    original: 0
                }

                var bid_task = $filter('filter')(bid_list, { 
                    'plan': plan }, true);

                _.each(bid_task, function(bid) {
                    var option = [item];

                    if(bid.revision === option[0].bid_revision) {
                        var revision = option_revision;

                        // if(option[0].revisions && option[0].revisions.length > 0)
                        //     revision = option[0].revisions[option[0].revisions.length-1].number;

                        if(option.length === 1) {
                            _.each(option[0].subtasks, function(sub) {
                                if(bid.task === sub.task && 
                                    sub.plan === plan && sub.revision === revision) {

                                    totals.option += 
                                        sub.is_overridden?sub.overridden_total:sub.total;

                                    if(sub.bid_subtask)
                                        totals.original += 
                                            (bid.subtasks[sub.subtask_array_id]) ? 
                                                bid.subtasks[sub.subtask_array_id].total : 0;
                                }
                            });
                        }
                    }
                });

                has_plan[0].original = totals.original;
                has_plan[0].option = totals.option;
                has_plan[0].value = has_plan[0].option - has_plan[0].original;
            } else {
                has_plan[0].value = 'X';
            }

            return has_plan;
        };

        var buildAndTotalPlans = function(
            options, plan_codes, matrix_values, bid_list, trade) {
            console.log('build the plan');
            matrix_values = [];
            _.each(options, function(option) {
                _.each(plan_codes, function(plan) {
                    buildPlan(plan.item, option, 
                        matrix_values, trade);
                });
            });

            _.each(options, function(option) {
                //var bids = $filter('filter')(bid_list, {'revision': option.bid_revision}, true)
                _.each(plan_codes, function(plan) {
                    planTotal(plan.item, option, 
                        matrix_values, bid_list, options);
                });
            });

            return matrix_values;
        };

        return {
            buildPlan: buildPlan,
            planTotal: planTotal,
            planOptionRevisionTotal: planOptionRevisionTotal,
            buildAndTotalPlans: buildAndTotalPlans
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/options/public/services/option-plan-service.js